module.exports = __webpack_public_path__ + "static/media/Sevenk_final-cover_rev-01.b2d344ed.png";